














import { defineComponent } from 'vue';
import { f7 } from 'framework7-vue';

import { Poll } from '../types';

import { appStoreMapper } from '@/store/appstore';
import { authStoreMapper } from '@/modules/auth/dist/store';
import { pollsStoreMapper } from '../store';

import PollsQuestionsIcon from './PollsQuestionsIcon.vue';

export default defineComponent({
  name: 'PollsHomeReminder',
  components: { PollsQuestionsIcon },
  computed: {
    show(): boolean {
      return !this.registrationPollAnswered && this.settings.showRegistrationPollReminder;
    },
    registrationPoll(): Nullable<Poll> {
      return this.polls.find((p) => p.placement === 'registration');
    },
    registrationPollAnswered(): boolean {
      let allAnswered = true;

      if (!this.registrationPoll || !this.isAuthorized) {
        return allAnswered;
      }

      this.registrationPoll.fields.forEach((field) => {
        if (field.isRequired && allAnswered) {
          allAnswered = this.getUserAnswer(this.registrationPoll, field.id) != null;
        }
      });

      return allAnswered;
    },
    ...appStoreMapper.mapGetters(['user']),
    ...authStoreMapper.mapGetters(['isAuthorized']),
    ...pollsStoreMapper.mapGetters(['settings', 'polls']),
  },
  methods: {
    getUserAnswer(poll: Nullable<Poll>, idField: number): Nullable<string> {
      return this.user?.pollAnswers?.find(
        (a) => a.idPoll === poll?.id && a.idPollField === idField,
      )?.value;
    },
    onClick() {
      if (this.settings.reminderProfileEdit) {
        f7.views.current.router.navigate('/profile/edit');
      }
    },
  },
});
